import { Head } from "vite-react-ssg";
import { Eyebrow } from "@/components/Eyebrow";
import { DemoForm } from "@/components/DemoForm";
import { DEMO_ENDPOINT } from "@/content/site";

export default function BookDemo() {
  const tz =
    typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC" : "UTC";
  return (
    <>
      <Head>
        <title>Book a demo — DjiniousLab</title>
        <meta name="description" content="Pick a few times that work and we'll confirm by email to set up your DjiniousLab demo." />
      </Head>
      <section className="bg-wash border-b border-border">
        <div className="mx-auto max-w-3xl px-6 py-16 text-center">
          <Eyebrow>Book a demo</Eyebrow>
          <h1 className="mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl">
            See DjiniousLab on your models
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
            Pick a few times that work for your team. We'll confirm by email and tailor the demo to your workflows.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-6 py-12">
        <div className="rounded-2xl border border-border bg-card p-6 shadow-soft sm:p-8">
          <DemoForm endpoint={DEMO_ENDPOINT} tz={tz} />
        </div>
      </section>
    </>
  );
}
